export default {
    appsDescriptions: {
        ap: {
            business: {
                id: 'account.appsDescriptions.ap.business'
            },
            private: {
                id: 'account.appsDescriptions.ap.private'
            }
        },
        cnc: {
            id: 'account.appsDescriptions.cnc'
        },
        gco: {
            id: 'account.appsDescriptions.gco'
        }
    },
    scopes: {
        ClinicStaff: {
            id: 'account.scopes.ClinicStaff'
        },
        Professional: {
            id: 'account.scopes.Professional'
        },
        Personal: {
            id: 'account.scopes.Personal'
        },
        Caregiver: {
            id: 'account.scopes.Caregiver'
        }
    },
    scopeInfos: {
        ClinicStaff: {
            id: 'account.scopeInfos.ClinicStaff'
        },
        Professional: {
            id: 'account.scopeInfos.Professional'
        },
        Personal: {
            id: 'account.scopeInfos.Personal'
        },
        Caregiver: {
            id: 'account.scopeInfos.Caregiver'
        }
    },
    platformInfos: {
        business: {
            id: 'account.platformInfos.business'
        },
        businessAndPrivate: {
            id: 'account.platformInfos.businessAndPrivate'
        },
        private: {
            id: 'account.platformInfos.private'
        }
    },
    headers: {
        acceptInvitation: {
            Organization: {
                id: 'account.headers.acceptInvitation.organization'
            },
            GCO: {
                FamilyLink: {
                    id: 'account.headers.acceptInvitation.gco.familyLink'
                },
                SharingRequest: {
                    id: 'account.headers.acceptInvitation.gco.sharingRequest'
                }
            }
        },
        accountPortal: {
            id: 'account.headers.accountPortal'
        },
        accountExists: {
            id: 'account.headers.accountExists'
        },
        appCatalog: {
            id: 'account.headers.appCatalog'
        },
        avatarAdjust: {
            id: 'account.headers.avatarAdjust'
        },
        avatarUpload: {
            id: 'account.headers.avatarUpload'
        },
        chooseCountry: {
            id: 'account.headers.chooseCountry'
        },
        chooseScope: {
            id: 'account.headers.chooseScope'
        },
        confirmGuardianEmail: {
            id: 'account.headers.confirmGuardianEmail'
        },
        confirmGuardianEmailPending: {
            id: 'account.headers.confirmGuardianEmailPending'
        },
        confirmGuardianEmailFailed: {
            id: 'account.headers.confirmGuardianEmailFailed'
        },
        editGuardianEmail: {
            id: 'account.headers.editGuardianEmail'
        },
        confirmAccountViaOTP: {
            id: 'account.headers.confirmAccountViaOTP'
        },
        confirmEmail: {
            id: 'account.headers.confirmEmail'
        },
        confirmEmailSuccess: {
            id: 'account.headers.confirmEmailSuccess'
        },
        confirmEmailFailed: {
            id: 'account.headers.confirmEmailFailed'
        },
        confirmEmailExpired: {
            id: 'account.headers.confirmEmailExpired'
        },
        confirmEmailInProgress: {
            id: 'account.headers.confirmEmailInProgress'
        },
        deleteAccount: {
            id: 'account.headers.deleteAccount'
        },
        mfa: {
            id: 'account.headers.mfa'
        },
        identityPassword: {
            id: 'account.headers.identityPassword'
        },
        legalConsents: {
            id: 'account.headers.legalConsents'
        },
        loggingOutInProgress: {
            id: 'account.headers.loggingOutInProgress'
        },
        marketingConsents: {
            id: 'account.headers.marketingConsents'
        },
        passwordHasBeenChanged: {
            id: 'account.headers.passwordHasBeenChanged'
        },
        resetPassword: {
            id: 'account.headers.resetPassword'
        },
        enterCode: {
            id: 'account.headers.enterCode'
        },
        changePassword: {
            id: 'account.headers.changePassword'
        },
        resetPasswordCurrentProvider: {
            id: 'account.headers.resetPasswordCurrentProvider'
        },
        resetPasswordSent: {
            id: 'account.headers.resetPasswordSent'
        },
        seeYouLater: {
            id: 'account.headers.seeYouLater'
        },
        setInformation: {
            id: 'account.headers.setInformation'
        },
        communicationAndPrivacyPreferences: {
            id: 'account.headers.communicationAndPrivacyPreferences'
        },
        setNewPassword: {
            id: 'account.headers.setNewPassword'
        },
        signIn: {
            id: 'account.headers.signIn'
        },
        signInApp: {
            id: 'account.headers.signInApp'
        },
        signOut: {
            id: 'account.headers.signOut'
        },
        signUp: {
            id: 'account.headers.signUp'
        },
        somethingWrong: {
            id: 'account.headers.somethingWrong'
        },
        supportedPlatforms: {
            id: 'account.headers.supportedPlatforms'
        },
        switchProfile: {
            id: 'account.headers.switchProfile'
        },
        subscribeUnsubsribeEmail: {
            id: 'account.headers.subscribeUnsubsribeEmail'
        },
        noOtherProfilesFound: {
            id: 'account.headers.noOtherProfilesFound'
        }
    },
    buttons: {
        confirmEmail: {
            id: 'account.buttons.confirmEmail'
        },
        confirmEmailCC: {
            id: 'account.buttons.confirmEmailCC'
        },
        confirmEmailExpiredResend: {
            id: 'account.buttons.confirmEmailExpiredResend'
        },
        confirmEmailSuccessContinue: {
            id: 'account.buttons.confirmEmailSuccessContinue'
        },
        confirmEmailFailedResend: {
            id: 'account.buttons.confirmEmailFailedResend'
        },
        confirmEmailFailedSupport: {
            id: 'account.buttons.confirmEmailFailedSupport'
        },
        deleteAccount: {
            id: 'account.buttons.deleteAccount'
        },
        goToLogin: {
            id: 'account.buttons.goToLogin'
        },
        logout: {
            id: 'account.buttons.logout'
        },
        manageIdentities: {
            id: 'account.buttons.manageIdentities'
        },
        changeEmail: {
            id: 'account.buttons.changeEmail'
        },
        changePassword: {
            id: 'account.buttons.changePassword'
        },
        resetPassword: {
            id: 'account.buttons.resetPassword'
        },
        setNewPassword: {
            id: 'account.buttons.setNewPassword'
        },
        resendOtp: {
            id: 'account.buttons.resendOtp'
        },
        resendOtpBtn: {
            id: 'account.buttons.resendOtpBtn'
        },
        resendOtpBtnLock: {
            id: 'account.buttons.resendOtpBtnLock'
        },
        resendOtpLock: {
            id: 'account.buttons.resendOtpLock'
        },
        signIn: {
            id: 'account.buttons.signIn'
        },
        signOut: {
            id: 'account.buttons.signOut'
        },
        signUp: {
            id: 'account.buttons.signUp'
        },
        switchIdentity: {
            id: 'account.buttons.switchIdentity'
        },
        tryAgainIn: {
            id: 'account.buttons.tryAgainIn'
        },
        resendCode: {
            id: 'account.buttons.resendCode'
        },
        resendCodeLock: {
            id: 'account.buttons.resendCodeLock'
        },
        resendEmail: {
            id: 'account.buttons.resendEmail'
        },
        resendEmailLock: {
            id: 'account.buttons.resendEmailLock'
        },
        verifyCodeCheck: {
            id: 'account.buttons.verifyCodeCheck'
        },
        editGuardianEmail: {
            id: 'account.buttons.editGuardianEmail'
        }
    },
    labels: {
        changeContourCloudPass: {
            id: 'account.labels.changeContourCloudPass'
        },
        designation: {
            id: 'account.labels.designation'
        },
        email: {
            id: 'account.labels.email'
        },
        businessEmail: {
            id: 'account.labels.email'
        },
        firstName: {
            id: 'account.labels.firstName'
        },
        lastName: {
            id: 'account.labels.lastName'
        },
        loginByContourCloud: {
            id: 'account.labels.loginByContourCloud'
        },
        gender: {
            id: 'account.labels.gender'
        },
        goBack: {
            id: 'account.labels.goBack'
        },
        female: {
            id: 'account.labels.female'
        },
        male: {
            id: 'account.labels.male'
        },
        licenceNumber: {
            id: 'account.labels.licenceNumber'
        },
        licenceType: {
            id: 'account.labels.licenceType'
        },
        marketingConsents: {
            id: 'account.labels.marketingConsents'
        },
        password: {
            id: 'account.labels.password'
        },
        confirmedPassword: {
            id: 'account.labels.confirmPassword'
        },
        newPassword: {
            id: 'account.labels.newPassword'
        },
        createPassword: {
            id: 'account.labels.createPassword'
        },
        oldPassword: {
            id: 'account.labels.oldPassword'
        },
        temporaryPassword: {
            id: 'account.labels.temporaryPassword'
        },
        personalIdentifierType: {
            id: 'account.labels.personalIdentifierType'
        },
        personalIdentifierValue: {
            id: 'account.labels.personalIdentifierValue'
        },
        professionalIdentifierType: {
            id: 'account.labels.professionalIdentifierType'
        },
        professionalIdentifierValue: {
            id: 'account.labels.professionalIdentifierType'
        },
        profile: {
            id: 'account.labels.profile'
        },
        scope: {
            id: 'account.labels.scope'
        },
        identityProvider: {
            id: 'account.labels.identityProvider'
        },
        registrationPrivacy: {
            id: 'account.labels.registrationPrivacy'
        },
        rememberMe: {
            id: 'account.labels.rememberMe'
        },
        resetPassword: {
            id: 'account.labels.resetPassword'
        },
        resendConfirmEmail: {
            id: 'account.labels.resendConfirmEmail'
        },
        sensitiveDataProfiling: {
            id: 'account.labels.sensitiveDataProfiling'
        },
        useContourCloudApp: {
            id: 'account.labels.useContourCloudApp'
        },
        phoneNumber: {
            id: 'account.labels.phoneNumber'
        },
        additionalInformation: {
            id: 'account.labels.additionalInformation'
        },
        yourProfilePhoto: {
            id: 'account.labels.yourProfilePhoto'
        },
        guardianEmail: {
            id: 'account.labels.guardianEmail'
        }
    },
    placeholders: {
        email: {
            id: 'account.placeholders.email'
        },
        firstName: {
            id: 'account.placeholders.firstName'
        },
        lastName: {
            id: 'account.placeholders.lastName'
        },
        password: {
            id: 'account.placeholders.password'
        },
        oldPassword: {
            id: 'account.placeholders.oldPassword'
        },
        newPassword: {
            id: 'account.placeholders.newPassword'
        },
        yourPassword: {
            id: 'account.placeholders.yourPassword'
        },
        confirmedPassword: {
            id: 'account.placeholders.confirmPassword'
        },
        temporaryPassword: {
            id: 'account.placeholders.temporaryPassword'
        },
        guardianEmail: {
            id: 'account.placeholders.guardianEmail'
        }
    },
    fieldsInfos: {
        password: {
            id: 'account.fieldsInfos.password'
        },
        newIdentityPassword: {
            id: 'account.fieldsInfos.newIdentityPassword'
        }
    },
    infos: {
        acceptInvitationInProgress: {
            id: 'account.infos.acceptInvitationInProgress'
        },
        availableFor: {
            id: 'account.infos.availableFor'
        },
        blockingIdentity: {
            id: 'account.infos.blockingIdentity'
        },
        matchingIdentities: {
            id: 'account.infos.matchingIdentities'
        },
        matchingIdentity: {
            id: 'account.infos.matchingIdentity'
        },
        noMatchingIdentity: {
            id: 'account.infos.noMatchingIdentity'
        },
        backTo: {
            id: 'account.infos.backTo'
        },
        confirmGuardianEmail: {
            id: 'account.infos.confirmGuardianEmail'
        },
        confirmGuardianEmailPending: {
            id: 'account.infos.confirmGuardianEmailPending'
        },
        confirmGuardianEmailFailed: {
            id: 'account.infos.confirmGuardianEmailFailed'
        },
        editGuardianEmail: {
            id: 'account.infos.editGuardianEmail'
        },
        confirmGuardianEmailResended: {
            id: 'account.infos.confirmGuardianEmailResended'
        },
        confirmEmail: {
            id: 'account.infos.confirmEmail'
        },
        confirmAccountViaOTP: {
            id: 'account.infos.confirmAccountViaOTP'
        },
        confirmEmailCC: {
            id: 'account.infos.confirmEmailCC'
        },
        confirmEmailSuccess: {
            id: 'account.infos.confirmEmailSuccess'
        },
        confirmEmailFailed: {
            id: 'account.infos.confirmEmailFailed'
        },
        confirmEmailExpired: {
            id: 'account.infos.confirmEmailExpired'
        },
        confirmEmailInProgress: {
            id: 'account.infos.confirmEmailInProgress'
        },
        contourCloudInfo: {
            id: 'account.infos.contourCloudInfo'
        },
        haveAccount: {
            id: 'account.infos.haveAccount'
        },
        identityPassword: {
            id: 'account.infos.identityPassword'
        },
        legalConsents: {
            id: 'account.infos.legalConsents'
        },
        loggingOutSuccessful: {
            id: 'account.infos.loggingOutSuccessful'
        },
        noAccount: {
            id: 'account.infos.noAccount'
        },
        profileSecure: {
            id: 'account.infos.profileSecure'
        },
        rejectInvitation: {
            id: 'account.infos.rejectInvitation'
        },
        resendOtp: {
            id: 'account.infos.resendOtp'
        },
        tryLoggingOutAgain: {
            id: 'account.infos.tryLoggingOutAgain'
        },
        switchProfile: {
            id: 'account.infos.switchProfile'
        },
        noOtherProfilesFound: {
            id: 'account.infos.noOtherProfilesFound'
        },
        guardianEmail: {
            id: 'account.infos.guardianEmail'
        },
        previousEmail: {
            id: 'account.infos.previousEmail'
        },
        enterNewGuardianEmail: {
            id: 'account.infos.enterNewGuardianEmail'
        }
    },
    intros: {
        addIdentityForm: {
            id: 'account.intros.addIdentityForm'
        },
        chooseCountry: {
            id: 'account.intros.chooseCountry'
        },
        chooseScope: {
            id: 'account.intros.chooseScope'
        },
        deleteAccount: {
            id: 'account.intros.deleteAccount'
        },
        provideOTP: {
            id: 'account.intros.provideOTP'
        },
        resetPassword: {
            id: 'account.intros.resetPassword'
        },
        resetPasswordCode: {
            id: 'account.intros.resetPasswordCode'
        },
        resetPasswordSent: {
            id: 'account.intros.resetPasswordSent'
        },
        signIn: {
            id: 'account.intros.signIn'
        },
        supportedPlatforms: {
            id: 'account.intros.supportedPlatforms'
        }
    },
    notes: {
        confirmGuardianEmail: {
            id: 'account.notes.confirmGuardianEmail'
        },
        note: {
            id: 'account.notes.note'
        },
        checkSpamFolder: {
            id: 'account.notes.checkSpamFolder'
        }
    },
    invitationInfo: {
        Organization: {
            id: 'invitation.invitationInfo.organization'
        },
        GCO: {
            SharingRequest: {
                id: 'invitation.invitationInfo.gco.sharingRequest'
            },
            FamilyLink: {
                id: 'invitation.invitationInfo.gco.familyLink'
            }
        }
    },
    validatorRules: {
        legalAge: {
            id: 'account.errors.validatorRules.legalAge'
        },
        newPassword: {
            id: 'account.errors.validatorRules.newPassword'
        },
        dateOfBirthNotInFuture: {
            id: 'account.errors.validatorRules.dateOfBirthNotInFuture'
        }
    },
    alerts: {
        resendCodeSuccess: {
            id: 'account.alerts.resendCodeSuccess'
        },
        accountIsToBeDeleted: {
            id: 'account.alerts.accountIsToBeDeleted'
        }
    },
    errors: {
        businessErrors: {
            EmailAlreadyExist: {
                id: 'account.errors.businessErrors.EmailAlreadyExist'
            },
            CCUserAlreadyExists: {
                id: 'account.errors.businessErrors.EmailAlreadyExist'
            },
            CCUserHasToAcceptPrivacyPolicy: {
                id: 'account.errors.businessErrors.CCUserHasToAcceptPrivacyPolicy'
            },
            InvalidOTP: {
                id: 'account.errors.businessErrors.InvalidOTP'
            },
            InvalidSignatureToken: {
                id: 'account.errors.businessErrors.InvalidSignatureToken'
            },
            InvitationNotFound: {
                id: 'account.errors.businessErrors.InvitationNotFound'
            },
            OldAndNewPasswordsMustBeDifferent: {
                id: 'account.errors.businessErrors.OldAndNewPasswordsMustBeDifferent'
            },
            TokenWrongFormat: {
                id: 'account.errors.businessErrors.TokenWrongFormat'
            },
            UserOrPasswordIncorrect: {
                id: 'account.errors.businessErrors.UserOrPasswordIncorrect'
            },
            UnableToLoginToContourCloud: {
                id: 'account.errors.businessErrors.UserOrPasswordIncorrect'
            },
            WrongPassword: {
                id: 'account.errors.businessErrors.WrongPassword'
            }
        },
        validatorRules: {
            sameAsPassphrase: {
                id: 'account.errors.validatorRules.sameAsPassphrase'
            }
        }
    },
    statuses: {
        Pending: {
            id: 'account.statuses.Pending'
        },
        Active: {
            id: 'account.statuses.Active'
        },
        Revoked: {
            id: 'account.statuses.Revoked'
        }
    }
};
